
const columns = () => {
    return [
        {
            title: '岗位名称',
            name: 'name',
            dataIndex: 'name',
            searchItem: {},
            tableItem: {
                width: '220px'
            }
        },
        {
            title: '岗位编码',
            name: 'code',
            dataIndex: 'code',
            searchItem: {},
            tableItem: {
                width: '220px'
            }
        },
        {
            title: '岗位分类',
            name: 'positionCategoryName',
            dataIndex: 'positionCategoryName',
            searchItem: {}
        },
        {
            title: '岗位分类',
            name: 'positionCategoryNames',
            dataIndex: 'positionCategoryNames',
            tableItem: {
                width: '220px'
            }
        },
        {
            title: '所属组织',
            name: 'orgNames',
            dataIndex: 'orgNames',
            tableItem: {
                width: '230px'
            }
        },
        // {
        //     title: '状态',
        //     name: 'state',
        //     dataIndex: 'state',
        //     tableItem: {},
        //     dict: [
        //         { code: 1, codeName: '有效' },
        //         { code: 0, codeName: '无效' }
        //     ],
        //     searchItem: {
        //         type: 'select'
        //     },
        //     tableItem: {}
        // }
    ]
}

const tableApi = (api = {}) => {
    return {
        path: 'position/list',
        ...api
    }
}

const position = (self, api) => {
    return {
        type: 'diy',
        initialValue: [],
        columns: columns(),
        rowName: 'positionBrandName',
        tableApi: tableApi(api)
    }
}

export default position